import { UserTagKeys, UserTagTypes } from '@medflex/shared-types';

export const DEFAULT_USER_TAGS = [
  {
    key: UserTagKeys.APPOINTMENT,
    value: 'Termin',
    type: UserTagTypes.SYSTEM,
  },
  {
    key: UserTagKeys.FINDINGS_INQUIRY,
    value: 'Befund',
    type: UserTagTypes.SYSTEM,
  },
  {
    key: UserTagKeys.GENERAL_INQUIRY,
    value: 'Frage',
    type: UserTagTypes.SYSTEM,
  },
  {
    key: UserTagKeys.REFERRAL,
    value: 'Überweisung',
    type: UserTagTypes.SYSTEM,
  },
  {
    key: UserTagKeys.REQUEST_FOLLOW_UP_PRESCRIPTION,
    value: 'Rezept',
    type: UserTagTypes.SYSTEM,
  },
  {
    key: UserTagKeys.CONNECT_TO_PHYSICIAN,
    value: 'Kontaktanfrage',
    type: UserTagTypes.SYSTEM,
  },
  {
    key: UserTagKeys.PHONE,
    value: 'Anruf',
    type: UserTagTypes.SYSTEM,
  },
  {
    key: UserTagKeys.DOCUMENT,
    value: 'Dokument',
    type: UserTagTypes.SYSTEM,
  },
  {
    key: UserTagKeys.FORWARDED_CALL,
    value: 'Weiterleitung',
    type: UserTagTypes.FORWARDED_CALL,
  },
  {
    key: UserTagKeys.MESSAGE,
    value: 'Nachricht',
  },
];

export const DEFAULT_TAG_GROUPS = [
  {
    value: 'Kanal',
  },
  {
    value: 'Anfragetyp',
  },
];

export const USER_TAGS_DESCRIPTION_MAX_LENGTH = 500;
export const USER_TAGS_NAME_MAX_LENGTH = 50;
